import { useEffect, useState, useContext } from "react";
import Sidebar from "../../../components/common/Sidebar";
import Navbar from "../../../components/common/Navbar";
import { AuthContext } from "../../../context/AuthContext";
import {
getCategories,
createCategory,
deleteCategory,
} from "../../../services/categoryApi";
import "./Categories.css";

const Categories = () => {
const { user } = useContext(AuthContext);

const [categories, setCategories] = useState([]);
const [name, setName] = useState("");
const [slug, setSlug] = useState("");
const [loading, setLoading] = useState(false);

const fetchCategories = async () => {
try {
const data = await getCategories();
setCategories(data);
} catch (err) {
console.log(err);
}
};

useEffect(() => {
fetchCategories();
}, []);

const handleCreate = async (e) => {
e.preventDefault();

try {
  setLoading(true);

  await createCategory({ name, slug });

  setName("");
  setSlug("");

  fetchCategories();
} catch (err) {
  alert("Failed to create category");
} finally {
  setLoading(false);
}


};

const handleDelete = async (id) => {
if (!window.confirm("Delete category?")) return;

try {
  await deleteCategory(id);
  fetchCategories();
} catch (err) {
  alert("Delete failed");
}


};

return (
<div className="categories-layout">
<Sidebar role={user.role} />

  <div className="categories-main">
    <Navbar />

    <div className="categories-content">

      {/* HEADER */}
      <div className="categories-header">
        <h2>Categories</h2>
        <p>Manage your product categories</p>
      </div>

      {/* CREATE CATEGORY */}
      <div className="category-create-card">
        <h3>Create Category</h3>

        <form
          onSubmit={handleCreate}
          className="category-form"
        >
          <div className="category-input-group">
            <label>Category Name</label>

            <input
              placeholder="Category Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="category-input-group">
            <label>Category Slug</label>

            <input
              placeholder="Slug (electronics, books)"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="category-create-btn"
          >
            {loading ? "Creating..." : "Create"}
          </button>
        </form>
      </div>

      {/* CATEGORY LIST */}
      <div className="category-list-card">

        <div className="category-list-header">
          <h3>Category List</h3>

          <span className="category-count">
            {categories.length} Categories
          </span>
        </div>

        <div className="category-table-wrapper">
          <table className="category-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Slug</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {categories.map((c) => (
                <tr key={c.id}>
                  <td>{c.id}</td>

                  <td className="category-name">
                    {c.name}
                  </td>

                  <td className="category-slug">
                    {c.slug}
                  </td>

                  <td>
                    <button
                      onClick={() => handleDelete(c.id)}
                      className="category-delete-btn"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>

    </div>
  </div>
</div>


);
};

export default Categories;